// @flow
import styled, { css } from 'styled-components';
import { H1 } from '@finect/tabular-core/Headings';
import { ButtonLined } from '@finect/tabular-core/ButtonLined';
import { Button } from '@finect/tabular-core/Button';
import { getFont } from '@finect/tabular-utils/getFont';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const InnerContent = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;
  flex: auto;
  padding: 16px;
  border-radius: ${({ theme }) => theme.borderRadius};
  margin-top: 40px;
  background-color: ${({ theme }) => theme.colors.terciaryLL};
  ${({ withBorder, theme }) => (withBorder ? `border-bottom: 1px solid ${theme.colors.uiM}` : '')};

  > div:last-child {
    flex-direction: column;
    align-items: center;

    margin-left: auto;
  }

  ${minMediaQueries.miniDesktop`
    ${({ withDescription }) =>
    !withDescription &&
      `
    flex-direction: row;
    align-items: center;
    `}
  `}

  ${maxMediaQueries.tablet`
  ${({ withBorder }) => withBorder && 'margin-bottom: 40px;'}
  
      ${({ withDescription }) =>
    withDescription &&
        `
        > div {
          display: flex !important;
          flex-direction: column !important;
          align-items: center;
          justify-content: center;
          margin: auto;
        }
      `}
  `}
`;

export const InnerBackground = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  height: 140px;
  background-image: ${({ cover }) =>
    (cover
      ? `url(${`https://www.finect.com/image/${cover})`}`
      : 'url("https://static.finect.com/img/background/group-header.jpg")')};
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;

  ${maxMediaQueries.miniDesktop`
    height: 190px;
    margin-top: -40px;
  `}
`;

export const IconBlock = styled.div`
  ${maxMediaQueries.phablet`
    > span {
      margin: 0;
      width: 80px;
      height: 80px;
    }
  `}
`;

export const InfoBlock = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  padding-left: 0;

  ${({ center }) =>
    center &&
    css`
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
    `}

  ${maxMediaQueries.tablet`
    align-items: center;

    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
    };

    ${({ center }) =>
    center &&
      css`
        align-items: center;
        flex-direction: column;
        justify-content: center;
      `}
  `}
`;

export const Name = styled(H1)`
  margin-right: 12px;

  &:not(:last-child) {
    padding-bottom: 0;
  }

  ${maxMediaQueries.tablet`
    ${getFont(3, 'compact')}
  `}
`;

export const NameBlock = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0 16px;
  vertical-align: center;
  color: ${({ theme }) => theme.colors.terciaryD};
  text-decoration: none;

  ${maxMediaQueries.tablet`
    padding-top: 16px;
    flex-flow: column;
    text-align: center;
  `}
`;

export const HeadlineBlock = styled.div`
  margin-bottom: 12px;
`;

export const ProfileExtra = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const ProfileActions = styled.div`
  display: flex;
  align-items: end;
  justify-content: center;
  flex-flow: column;

  button,
  a:not(:first-of-type) {
    margin-left: 6px;
  }
`;

export const SponsorText = styled.span`
  color: ${({ theme }) => theme.colors.terciaryD};
  font-size: 12px;
  font-weight: 400;
  bottom: -10px;
  margin-left: auto;

  ${maxMediaQueries.tablet`bottom: -5px;`}
`;

// TODO: Todos estos botones tienen que estar estandarizados en components

export const ConfigButton = styled(Button)`
  display: flex;
  padding: 6px 8px;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.uiD};

  &:not([disabled]):hover {
    background-color: transparent;
    color: ${({ theme }) => theme.colors.uiDD};
  }
`;

export const WriteButton = styled(ButtonLined)`
  display: flex;
  align-items: center;
  padding: 6px 12px;

  &:not([disabled]):hover {
    border-color: ${({ theme, secondary }) => (secondary ? theme.colors.secondaryM : theme.colors.primaryM)};
    background-color: ${({ theme, secondary }) => (secondary ? theme.colors.secondaryM : theme.colors.primaryM)};
  }

  svg {
    margin-right: 6px;
  }
`;

export const MessageButton = styled(WriteButton)`
  border: 0;

  &:not([disabled]):hover {
    background-color: transparent;
    color: ${({ theme, secondary }) => (secondary ? theme.colors.secondaryD : theme.colors.primaryD)};
  }
`;

export const FollowButton = styled(WriteButton)`
  background-color: ${({ theme, followed }) => (followed ? theme.colors.primary : theme.colors.secondary)};
`;
